import ViewerUserPreferences from 'models/user/ViewerUserPreferences';
import LocaleMapper from 'utils/LocaleMapper';

export default {
    garminAppStoreUrl: window.GARMIN_APP_URL,

    getAppStoreUrl: function(device) {
        if (device) {
            var language = ViewerUserPreferences.get('preferredLocale');
            var fullLocale = LocaleMapper.getFullLocale(language);
            var appStoreUrl = this.garminAppStoreUrl;

            appStoreUrl = appStoreUrl.replace('{locale}', fullLocale);

            appStoreUrl = appStoreUrl + '&sku=' + device.get('partNumber') + '&unitId=' + device.get('deviceId');

            return appStoreUrl;
        }
    },

    getAppUrl: function(queue) {
        // https://apps-dev.garmin.com/{locale}/apps/{appId}
        var appUrl = this.garminAppStoreUrl;
        appUrl += '/' + queue.metaData.appDetails.id;

        var language = ViewerUserPreferences.get('preferredLocale');
        var fullLocale = LocaleMapper.getFullLocale(language);

        appUrl = appUrl.replace('{locale}', fullLocale);

        return appUrl;
    }
};
